// Import the functions you need from the SDKs you need
import { FirebaseOptions, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig: FirebaseOptions = {
  apiKey: 'AIzaSyCQj639XYcGKtgAHTeBhIqXvjYpcV83I6k',
  authDomain: 'ai-marketing-agents-406e0.firebaseapp.com',
  databaseURL:
    'https://ai-marketing-agents-406e0-presence.europe-west1.firebasedatabase.app',
  projectId: 'ai-marketing-agents-406e0',
  storageBucket: 'ai-marketing-agents-406e0.firebasestorage.app',
  messagingSenderId: '610135364519',
  appId: '1:610135364519:web:743f2d20c53e451f919c82',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const rtdb = getDatabase(app);

const limitsRTDB = getDatabase(
  app,
  'https://ai-marketing-agents-406e0-account-limits.europe-west1.firebasedatabase.app',
);

// Configure Functions based on environment
const isDevelopment = import.meta.env.DEV;
const devHostingUrl =
  import.meta.env.VITE_HOSTING_URL || 'http://localhost:5002';
const functions = isDevelopment
  ? getFunctions(app, devHostingUrl)
  : getFunctions(app, 'https://internal-api.superfunnel.ai');

const auth = getAuth(app);
const storage = getStorage(app); // Default Firebase Storage
const agentFilesStorage = getStorage(app, 'gs://agent-files-f8gmv'); // Agent files bucket

// Connect to shell directly
// connectFunctionsEmulator(functions, 'localhost', 5002);

export { agentFilesStorage, auth, db, functions, limitsRTDB, rtdb, storage };
